import { FC } from 'react';
import CalculateOutlined from '@mui/icons-material/CalculateOutlined';
import TabsPanel from 'further-ui/components/TabsPanel';
import Page from 'components/new/Page';
import { AccountingTab } from 'adminConstants/routes';
import BalanceSheet from './BalanceSheet';
import GeneralLedger from './GeneralLedger';
import TrialBalance from './TrialBalance';
import IncomeStatement from './IncomeStatement';
import CashFlowStatement from './CashFlowStatement';
import ScheduleOfInvestments from './ScheduleOfInvestments';

const FundAccounting: FC = () => {
  const tabs = [
    {
      key: AccountingTab.GeneralLedger,
      label: 'General ledger',
      urlParam: AccountingTab.GeneralLedger,
      content: <GeneralLedger />,
    },
    {
      key: AccountingTab.TrialBalance,
      label: 'Trial balance',
      urlParam: AccountingTab.TrialBalance,
      content: <TrialBalance />,
    },
    {
      key: AccountingTab.BalanceSheet,
      label: 'Balance sheet',
      urlParam: AccountingTab.BalanceSheet,
      content: <BalanceSheet />,
    },
    {
      key: AccountingTab.IncomeStatement,
      label: 'Income statement',
      urlParam: AccountingTab.IncomeStatement,
      content: <IncomeStatement />,
    },
    {
      key: AccountingTab.CashFlowStatement,
      label: 'Cash flow statement',
      urlParam: AccountingTab.CashFlowStatement,
      content: <CashFlowStatement />,
    },
    {
      key: AccountingTab.ScheduleOfInvestments,
      label: 'Schedule of investments',
      urlParam: AccountingTab.ScheduleOfInvestments,
      content: <ScheduleOfInvestments />,
    },
  ];

  return (
    <Page
      tabTitle="Accounting"
      heading="Accounting"
      headingIcon={CalculateOutlined}
      spacing="sm"
    >
      <TabsPanel keepAlive useTabsUrls fullHeight tabs={tabs} />
    </Page>
  );
};

export default FundAccounting;
